export default __webpack_public_path__ + "static/media/request-started.707b37e3.svg";